// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__XCjy4","close-button":"style_close-button__82dtR"};